import { c as _c } from "react/compiler-runtime";
import { Divider } from "@flat-ui";
import { Box, Grid } from "@mui-wrapper";
import { DEFAULT_FONT_FAMILY, withEllipsisThreeLines } from "@styles/common-styles";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * A page container/wrapper with a header section where a title and description can be displayed on the left
 * and actions buttons can be displayed on the right.
 */
export function PageContainer(t0) {
  const $ = _c(28);
  const {
    children,
    title,
    description,
    actionButtons,
    dataTestId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      boxShadow: `0 1px 0 0 ${PALETTE_VARS.divider}`,
      paddingTop: 2
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      minHeight: "46px",
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      color: "text.primary",
      flexWrap: "nowrap"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== actionButtons) {
    t4 = actionButtons ? {
      xs: 12,
      sm: 12,
      md: 6,
      lg: 7,
      xl: 8
    } : 12;
    $[3] = actionButtons;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontFamily: DEFAULT_FONT_FAMILY,
      fontSize: "14px",
      color: "text.primary"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== title) {
    t6 = <Grid sx={t5}>{title}</Grid>;
    $[6] = title;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      ml: "35px",
      ...withEllipsisThreeLines
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== description) {
    t8 = <Grid sx={t7}>{description}</Grid>;
    $[9] = description;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t6 || $[13] !== t8) {
    t9 = <Grid container={true} sx={t3} size={t4}>{t6}{t8}</Grid>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== actionButtons) {
    t10 = actionButtons && <Grid sx={{
      minHeight: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      svg: {
        height: "24px",
        width: "24px"
      }
    }} size={{
      xs: 12,
      sm: 12,
      md: 6,
      lg: 5,
      xl: 4
    }}>{actionButtons}</Grid>;
    $[15] = actionButtons;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <Grid container={true} sx={t2}>{t9}{t10}</Grid>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Divider />;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      width: "100%"
    };
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== children) {
    t14 = <Box component="div" sx={t13}>{children}</Box>;
    $[22] = children;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== dataTestId || $[25] !== t11 || $[26] !== t14) {
    t15 = <Box component="div" sx={t1} data-testid={dataTestId}>{t11}{t12}{t14}</Box>;
    $[24] = dataTestId;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  return t15;
}